<template>
	<div class="wrapper">
		<div class="bg">
			<img src="@/assets/image/coupon-bg.png" class="auto-img" style="width: 100%;height: 450px;" />
		</div>
		<div class="top-title-box">
			<!-- <div class="left-icon">
				
			</div> -->
			<div class="page-title">优惠券详情</div>
		</div>
		<div class="main">
			<div class="coupon-top">
				<img src="@/assets/image/coupon-content-bg.png" class="auto-img" />
			</div>
			<div class="coupon-info">
				<div class="coupon-title">小蜂蜂2000元代金券</div>
				<div class="coupon-subtext">券有效期：2024-12-15至2025-05-01</div>
			</div>
			<div class="coupon-code">
				<div class="code-number">zyhq 2025 0103 0001</div>
				<div class="re-code">
					<img src="@/assets/image/er-code.png" class="auto-img" />
				</div>
				<div class="qr-code">
					<img src="@/assets/image/qr-code.png" class="auto-img" />
				</div>
                <van-button class="submit-btn">立即核销</van-button>
				<div class="dashed-line"></div>
				<div class="use-rules">
					<div class="rules-title">
						<div class="title-icon"></div>
						<div class="title-content">使用说明</div>
					</div>
					<div class="rules-items">
						券有效期：2024-12-15至2025-05-01
						可使用区域：不限制；
						可使用车型：不限制；
						在活动期间内，每个用户仅限核销一张。同一账号视为一
						用户；
						本券核销后将根据券面金额转换成对应金额优惠券；
						本券不可兑换现金，不参与除小蜂蜂闪运APP运输业务以
						外一切服务；
						券最终解释权归深圳市中永物流有限公司所有
					</div>
				</div>
			</div>
		</div>
		<div class="footer">
			<img src="@/assets/image/footer-bg.png" style="width: 100%;height: 130px;" />
			<img src="@/assets/image/top-logo.png" class="center-logo" />
		</div>
	</div>
</template>

<script>
import { Button } from 'vant';
export default {
    components:{
        [Button.name]:Button,
    },
}
</script>

<style lang="scss" scoped>
	.wrapper {
		width: 100%;
		height: 100%;
        overflow-y: auto;
		.top-title-box {
			height: 75px;
			position: relative;
			z-index: 2;
			display: flex;
			align-items: flex-end;
			justify-content: center;
			.left-icon {
				position: absolute;
				top: 50%;
				left: 12px;
				background-color: #F9F9F9;
				width: 20px;
				height: 20px;
			}
			.page-title {
				color: #000000;
				font-size: 17px;
				font-weight: 560;
			}
		}
		.main {
			position: relative;
			z-index: 2;
			margin-top: 15px;
			padding: 0 12px;
			margin-bottom: 100px;
			.coupon-top {
				width: 100%;
				height: 134px;
				padding: 0 4px;
				position: absolute;
				top: 0;
				left: 0;
                box-sizing: border-box;
			}
			.coupon-info {
				width: 100%;
				height: 134px;
				position: relative;
				z-index: 2;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				.coupon-title {
					color: #3D3833;
					font-size: 24px;
					font-weight: 550;
				}
				.coupon-subtext {
					color: #85807B;
					font-size: 12px;
                    margin-top: 10px;
				}
			}
			.coupon-code {
				background-color: #ffffff;
				padding: 24px 33px;
				display: flex;
				flex-direction: column;
				align-items: center;
				box-shadow: 0px -6px 12px 2px rgba(204,181,159,0.1);
				margin-top: -20px;
				position: relative;
				z-index: 2;
				.code-number {
					font-size: 16px;
					color: #3D3833;
					letter-spacing: 5px;
				}
				.re-code {
					width: 100%;
					height: 84px;
					margin: 16px 0;
					margin-top: 9px;
				}
				.qr-code {
					width: 133px;
					height: 133px;
					margin-bottom: 32px;
				}
                .submit-btn {
                    color:#ffffff;
                    background: linear-gradient( 180deg, #FFBD2D 0%, #EC892E 100%);
                    box-shadow: 0px 4px 14px 1px rgba(255,122,0,0.5);
                    width:187px;
                    height:40px;
                    border: none;
                    border-radius: 8px;
                }
				.dashed-line {
					width: 100%;
					height: 1px;
					border-bottom: 1px dashed #C9C2BB;
					margin-top: 40px;
				}
				.use-rules {
					margin-top: 10px;
					.rules-title {
						display:flex;
						align-items: center;
                        margin-bottom: 10px;
					}
					.title-icon {
						width: 10px;
						height: 10px;
						border: 2px solid #3D3833;
						border-radius: 50%;
						background-color: #EC7E2E;
						margin-right: 4px;
					}
					.title-content {
						color: #3D3833;
						font-size: 16px;
						font-weight: 550;
					}
					.rules-items {
						color: #85807B;
						font-size: 12px;
					}
				}
			}
		}
		.footer {
			width: 100%;
			position: fixed;
			bottom: 0;
			left: 0;
			z-index: 2;
			.center-logo {
				width: 175px;
				height: 42px;
				position: absolute;
				top: 40%;
				left: 50%;
				transform: translateX(-40%);
			}
		}
		.auto-img {
			width: 100%;
			height: 100%;
		}
		.bg {
			width:100%;
			height: 100%;
			background: linear-gradient( 180deg, #FFF7DB 0%, #F9F9F9 54%, #F9F9F9 100%);
			position: absolute;
			top: 0;
			left: 0;
		}
	}
</style>